import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetRoleModel } from "@core/model/query-model-role";
import { roleFormDefault } from "./form.default";
import { RoleFormSchema } from "./form.rule";

export const useFormDefaultRole = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetRoleModel | undefined) => {
    return !cachedValue
      ? roleFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as RoleFormSchema);
  };

  return {
    getDefault,
  };
};
